import { render, staticRenderFns } from "./liaison.vue?vue&type=template&id=db1759e4&scoped=true"
import script from "./liaison.vue?vue&type=script&lang=js"
export * from "./liaison.vue?vue&type=script&lang=js"
import style1 from "./liaison.vue?vue&type=style&index=1&id=db1759e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1759e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db1759e4')) {
      api.createRecord('db1759e4', component.options)
    } else {
      api.reload('db1759e4', component.options)
    }
    module.hot.accept("./liaison.vue?vue&type=template&id=db1759e4&scoped=true", function () {
      api.rerender('db1759e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/liaison.vue"
export default component.exports